export type SearchShape<Keys extends string> = { [Key in Keys]?: string };

export type SearchKeyMap<Keys extends string> = { readonly [Key in Keys]: Key };

export type SearchValues = Record<string, string | undefined>;

export function buildQueryString(search: SearchValues | undefined): string {
  if (!search) {
    return '';
  }

  const searchParams = new URLSearchParams();

  for (const [key, value] of Object.entries(search)) {
    if (value) {
      searchParams.set(key, value);
    }
  }

  const queryString = searchParams.toString();

  return queryString ? `?${queryString}` : '';
}
